export const logo = require('./oracle-o-red.svg').default;
export const pebble = require('./pebble.png').default;
export const modalTexture = require('./modal-texture.png').default;
